import { Card, Button, makeStyles, mergeClasses } from '@fluentui/react-components';
import { AddFilled } from '@fluentui/react-icons';
import type { ReactNode } from 'react';
import { SQUARE_CARD_HEIGHT } from './Square.constants';
import { useSquareCardStyles } from './Square.styles';

const useStyles = makeStyles({
  card: {
    height: SQUARE_CARD_HEIGHT,
    padding: '0 !important',
  },
});

type TProps = {
  children: ReactNode;
  handleCreate: () => void;
};

/**
 * "New product" / "New jurisdiction" placeholder card.
 */
export const SquareButton = ({ children, handleCreate }: TProps) => {
  const classes = useStyles();
  const squareClasses = useSquareCardStyles();

  return (
    <Card className={mergeClasses(squareClasses.card, classes.card)}>
      <Button
        appearance="transparent"
        size="large"
        icon={<AddFilled />}
        onClick={handleCreate}
        className="w-full h-full"
      >
        {children}
      </Button>
    </Card>
  );
};
